/**
 * This is a solution to fix the 'Cannot read properties of null (reading 'useState')'
 * error which occurs in the Manager component from @restart/ui.
 * 
 * We create a component with the same name that doesn't use hooks in an illegal way.
 */

import React from 'react';

// Create a replacement for the problematic Manager component
function Manager(props) {
  // Simply render children directly without using hooks
  return <>{props.children}</>;
}

// React component for handling popper.js positioning
function PopperWrapper(props) {
  return <div style={{ position: 'relative' }}>{props.children}</div>;
}

// Export our fixed components
export { Manager, PopperWrapper };

// To ensure this component is used, we add it to the window object
if (typeof window !== 'undefined') {
  // Save a reference globally where webpack can find it
  window.__FixedReactComponents__ = {
    Manager,
    PopperWrapper
  };
}